var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./swiper.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-153bc868\"}!../../vue-loader/lib/selector?type=template&index=0!./swiper.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/var/atlassian/application-data/bamboo/xml-data/build-dir/196609/YOOR-WEB0-H5/h5/node_modules/vue-awesome-swiper/src/swiper.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] swiper.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-153bc868", Component.options)
  } else {
    hotAPI.reload("data-v-153bc868", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome-swiper/src/swiper.vue
// module id = 374
// module chunks = 6